<div class="content-wrapper">
    <div class="container">
        <a class="btn btn-light fixed-button"></a>
        <div class="row">
            <div class="col-12">
                <img class="img-fluid welcome-image middle" src="assets/img/placeholder-updated.jpg" alt="" (click)="onNext()">
            </div>
        </div>
    </div>
</div>